import { Button } from '@ddone/ui';
import { ArrowRight, CheckCircle2, ShieldCheck } from 'lucide-react';
import { useState } from 'react';
import { beginDesktopLogin, isTauriDesktop } from '../desktop/tauri-bridge';

export function LoginScreen() {
  const [error, setError] = useState<string>();
  const login = async () => {
    if (isTauriDesktop()) {
      try {
        setError(undefined);
        await beginDesktopLogin();
      } catch (cause) {
        setError(cause instanceof Error ? cause.message : 'Login desktop non riuscito');
      }
      return;
    }
    const target = `${window.location.pathname}${window.location.search}`;
    window.location.assign(`/api/v1/auth/login?returnTo=${encodeURIComponent(target)}`);
  };
  return (
    <main className="dd-login">
      <section className="dd-login-brand">
        <a href="/" className="dd-logo dd-logo--large" aria-label="DDone home">
          <span>D</span>Done
        </a>
        <div>
          <p className="dd-eyebrow">Workspace privato</p>
          <h1>Tutto il lavoro dell’agenzia, finalmente nello stesso posto.</h1>
          <p>
            Clienti, progetti, attività, note condivise e scadenze operative con permessi granulari.
          </p>
        </div>
        <ul>
          <li>
            <CheckCircle2 /> Collaborazione in tempo reale
          </li>
          <li>
            <ShieldCheck /> Accesso protetto dal servizio di identità aziendale
          </li>
        </ul>
      </section>
      <section className="dd-login-card">
        <div className="dd-login-mark">D</div>
        <h2>Bentornato</h2>
        <p>
          Accedi con l’account della tua organizzazione. Le credenziali non vengono memorizzate da
          DDone.
        </p>
        {error ? <p className="dd-inline-error">{error}</p> : null}
        <Button onClick={() => void login()} className="dd-login-button">
          Accedi <ArrowRight size={18} />
        </Button>
        <small>La sessione viene protetta e collegata al tuo account aziendale.</small>
      </section>
    </main>
  );
}
